import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BasicUser } from 'src/app/domain/models/User';
import { LoadOrderListItem } from 'src/app/domain/models/LoadOrder';
import { ContainerLoad, LoadFilters, MyLoadRequest } from 'src/app/domain/models/Pallet';

import { transportTypes, TransportTypeUtils } from 'src/app/ui/util/transportType.Utils';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { FilterService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { AuthApiService } from 'src/app/application/service/AuthService';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ProfileService } from 'src/app/application/service/ProfileService';
import { Profile, ProfileContactInfo } from 'src/app/domain/models/Profile';
import { Routes } from 'src/app/infrastructure/routes';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { FilterLoadsUtils, MyLoadsFilterProgram } from 'src/app/ui/util/custom-filters-my-loads';
import { BasicSelect } from 'src/app/ui/util/select-utils';
import { excelUtils } from 'src/app/ui/util/excel-utils';

@Component({
  selector: 'app-user-load-containers-orders-program',
  templateUrl: './user-load-containers-orders-program.component.html',
  styleUrls: ['./user-load-containers-orders-program.component.css'],


})
export class UserLoadContainersOrdersProgramComponent {

    profile: ProfileContactInfo | undefined
    companyName: string = ""
    orders: LoadOrderListItem[] = []
    shipments: LoadOrderListItem[] = []
    searchTerm: string = '';

    containerLoads: ContainerLoad[] = []

    requestLoad: MyLoadRequest = {
      years: [],
      isClosedSale: true,
      clients: [],
      containers: [],
      programs: [],
      ships: [],
      species: [],
      varieties: [],
      transportTypes: [],
      weeks: []
    }
    totalCount = 0;
    pageSize = 100;

    loading: boolean = false
    year: number = new Date().getFullYear()

    programFilter: MyLoadsFilterProgram | undefined;
    selectedCompanies: Profile[] = [];
    selectedPrograms: number[] = [];
    selectedSpecies: string[] = []
    selectedContainers: string[] = []
    selectedVarieties: string[] = []
    selectedShip: string[] = []
    selectedWeeks: number[] = []
    selectedTransportTypes: number[] = [];

    filteredRegisters: ContainerLoad[] = []
    containerFilter: SelectItem[] = []
    weekFilter: SelectItem[] = []
    importerFilter: SelectItem[] = []
    specieFilter: SelectItem[] = []
    varietyFilter: SelectItem[] = []
    shipFilter: SelectItem[] = []
    profileBasic: BasicUser | undefined

    numberProgramsFilter: SelectItem[] = []

    transportSelect: BasicSelect[] = transportTypes;
    lang: string = 'en';
    yearSelect: number[] = []

    years: number[] = []

    profileUser: BasicUser | undefined


    breadcrumbItems: MenuItem[] = []
    breadcrumbHomeItem: MenuItem = {}

    constructor(
      private _router: Router,
      private _messageService: MessageService,
      private _palletService: PalletGateway,
      public translateService: TranslateService,
      private _authService: AuthGateway,
      private _profileService: ProfileService

    ) {
      this.getYears()
      if (this._router.getCurrentNavigation()?.extras?.state?.['year'] !== undefined) {
        this.year = this._router.getCurrentNavigation()?.extras.state?.['year'];
      }
    }

    ngOnInit(): void {

      this.profileUser = this._authService.getUser()

      let breadcrumbMenuItemLabel1 = 'Container view'
      let breadcrumbHomeMenuItemLabel = 'Reports'

      if(this.profileUser) {
        this.lang = this.profileUser.lang;
        switch(this.profileUser.lang) {
          case 'en':
            breadcrumbMenuItemLabel1 = 'Containers view'
            breadcrumbHomeMenuItemLabel = 'Reports'
            break
          case 'es':
            breadcrumbMenuItemLabel1 = 'Vista Contenedores'
            breadcrumbHomeMenuItemLabel = 'Reportes'
            break
        }
      }

      this.configFilter()

      this.breadcrumbItems = [{ label: breadcrumbMenuItemLabel1, disabled: true}]
      this.breadcrumbHomeItem = { label: breadcrumbHomeMenuItemLabel, routerLink: '/' + Routes.userLoadOrdersProgram };
      this.getLoadContainerFilters()
      this.companyName = this._authService.getUser()?.companyName ?? ""
      this._profileService.getContactInfo().subscribe({
        next: (v) => {
          this.profile =  v
        },
        error: (e) => {
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translateService.instant('MessageService.Summary.FailedAction'),
            detail: this.translateService.instant('MessageService.ProfileMessageService.SingleRetrieveError') });
        },
      })
    }

    getYears() {
      let current = new Date()
      let currentYear = current.getFullYear()

      for(let i = 2023; i <= currentYear; i++) {
        this.years.push(i)
      }
    }

    filterLoads() {
      if (!this.searchTerm.trim()) {
        // Si el término de búsqueda está vacío, mostrar todos los pedidos
        this.filteredRegisters = this.containerLoads;
      } else {
        // Filtrar los pedidos basados en el término de búsqueda
        this.filteredRegisters = this.containerLoads.filter(product =>
          product.importer?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          product.week?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          product.etd?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          product.eta?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          product.containerNumber?.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          product.ship?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          product.departurePort?.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          product.destinationPort?.toLowerCase().includes(this.searchTerm.toLowerCase())
        )
      }
    }

    downloadExcelContainer() {
    this.setUpFilter();
    this.loading = true;
    this._palletService.downloadMyContainerLoad(this.requestLoad).subscribe({
      next: (resultBlob) => {
          const contentDisposition = resultBlob.headers.get('Content-Disposition');
          let nombreArchivo = 'CONTAINER';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename=([^]+);/);

            if (match && match[1]) {
                nombreArchivo = match[1];
            }

            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }else{
          excelUtils.downloadExcel(resultBlob.body, nombreArchivo);
        }

        this.loading = false;
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
        summary: this.translateService.instant('MessageService.Summary.FailedAction'),
        detail:  this.translateService.instant('MessageService.Excel.FailedDownload') })
        this.loading = false;
      }
    })
    }

    translateTextExcel(text: string) {
      return this.translateService.instant(`UserPages.UserLoadContainersOrders.MainTable.${text}`);
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
      });
      let date = new Date()
      var FileSaver = require('file-saver');
      FileSaver.saveAs(data, fileName + '-' + date.getDate()  + '-' + (date.getMonth() + 1) + '-' +date.getFullYear() + EXCEL_EXTENSION);
    }

    loadContainerPage(event: any)
    {
      const pageNumber = Math.floor(event.first / event.rows) + 1;
      const pageSize = event.rows;

      this.loadContainer(pageNumber, pageSize);
    }

    loadContainer(pageNumber: number = 1, pageSize: number = 100){
      this.loading = true;
      let config = FilterLoadsUtils.getFilterProgramConfig()

      if(config)
        {
        if(config.year){
          this.year = config.year
        }
      }

      this.setUpFilter(pageNumber, pageSize);

      this._palletService.getUserContainerLoadPaged(this.requestLoad).subscribe({
        next: (v) => {
          this.loading = false;
          this.containerLoads = v.items
          this.filteredRegisters = v.items
          this.totalCount = v.totalCount
          // this.configFilter()
        },
        error: (e) => {
                  this.loading = false
        console.log(e)
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Error al consultar los registros.' });
        }
      })
    }

    buildFilters(loadFilters: LoadFilters)
    {
        this.containerFilter = []
        this.numberProgramsFilter = []
        this.weekFilter = []
        this.specieFilter = []
        this.shipFilter = []
        this.varietyFilter = []
        this.importerFilter = []

        if(loadFilters.containers.length > 0)
        {
          loadFilters.containers.map(item => {
            this.containerFilter.push({ label: item, value: item })
          })
        }


        loadFilters.weeks.map(item => {
          this.weekFilter.push({label :item.toString(), value: item} )
        })



        loadFilters.clients.map(item => {
          this.importerFilter.push({ label: item.companyName, value: item.id })
        })



        loadFilters.species.map(item => {
          this.specieFilter.push({ label: item, value: item })
        })



        loadFilters.varieties.map(item => {
          this.varietyFilter.push({ label: item, value: item })
        })



        loadFilters.ships.map(item => {
          this.shipFilter.push({ label: item, value: item })
        })


        loadFilters.programs.map(item => {
            this.numberProgramsFilter.push({ label: item.toString(), value: item })
          })
    }

    getTransportName(transportType: number)
    {
      return TransportTypeUtils.getTransportName(this.translateService.currentLang, transportType);
    }

    goToLoadsPage(): void {
      this.clearFilters()
      this._router.navigate([Routes.userLoadOrdersProgram]);
    }

    clearFilters() {
      sessionStorage.removeItem("dt-masterload-session")
    }

    @ViewChild('loadContainersTable') dt: any;

    configFilter()
    {
      this.programFilter = FilterLoadsUtils.getFilterProgramConfig()

      if(this.programFilter)
      {
        if(this.programFilter.profileName)
        {
          this.selectedCompanies = [];
        }

        if(this.programFilter.programId)
        {
          this.selectedPrograms = [];
          this.selectedPrograms.push(this.programFilter.programId)
        }

        if(this.programFilter.transportType != undefined)
        {
          this.selectedTransportTypes = [];
          this.selectedTransportTypes.push(this.programFilter.transportType);
        }

        if(this.programFilter.year)
        {
          this.yearSelect.push(this.programFilter.year);
        }


      }

      this.updateSelectedYear()
      this.setUpFilter()
      this.getLoadContainerFilters()

    }

  changeFilter()
  {
    this.setUpFilter()
    this.loadContainer()
    this.getLoadContainerFilters()
  }

    getLoadContainerFilters()
    {
      this.loading = false;

      this._palletService.getLoadsFilter(this.requestLoad).subscribe({
        next: (v) => {
            this.buildFilters(v);
        },
        error: (e) => {
          this.loading = false
          console.log(e)
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los Master Loads.' });
        }

      })
    }



    updateSelectedYear()
    {
      this.yearSelect = []
      this.yearSelect.push(this.year);
    }

    filterTable(event: any) {
      let filterData  = event.filteredValue;
      this.buildFilters(filterData)
    }

    removeConfigFilter()
    {
      FilterLoadsUtils.removeFilterProgramConfig()
    }

    searchLoadContainers(event: any)
    {
      this.removeConfigFilter()
      if(event.value.length > 0)
      {
        this.year = this.yearSelect[0];
        this.loadContainer()
      }else{
        this.containerLoads = []
        this.filteredRegisters = []
        this.yearSelect = []
      }
    }

      setUpFilter(pageNumber: number = 1, pageSize: number = 100)
    {

      this.requestLoad.years = this.yearSelect;
      this.requestLoad.pageNumber = pageNumber;
      this.requestLoad.pageSize = pageSize;
      this.requestLoad.programs = this.selectedPrograms;
      this.requestLoad.transportTypes = this.selectedTransportTypes.map(x => x);
      this.requestLoad.ships = this.selectedShip.map(x => x);
      this.requestLoad.species = this.selectedSpecies.map(x => x);
      this.requestLoad.clients = this.selectedCompanies.map(x => x.id);
      this.requestLoad.containers = this.selectedContainers.map(x => x);

    }

  }
